/* Copyright (c) 2023 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum AccountSettingsState {
    SIGN_OUT,
    RESET_APP,
}
